import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class TemplatesToEmailsTiersModel extends BaseModel {
  tiers = []

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {};

  attributeLabels = {};
}
